// 商品ページ 注文オプション（受取方法・配送/受取日カレンダー）の挙動制御。
// Step1/2a でインラインから外部化、Step2b で脱jQuery＋Flatpickr化。
// 設定値は同スニペットの JSON ブロック #k-order-options-config から読む。
// カレンダーは Flatpickr（自己ホスト）。日本語ロケールはこのファイル内に内蔵。
// --- Horizon 移植差分（2026-07-03・出自: Dawn assets/k_product-order-options.js）---
// ① フォームIDのフォールバック検索を Horizon 純正の 'BuyButtons-ProductForm-…' 形式へ（2箇所）
// ② 送信ガードの取り付け先を <product-form> → Horizon の <product-form-component> へ
// ③ 【重要】Horizon は on:submit 等のイベントを document 側で委任処理するため、後から登録する
//    我々の capture リスナーでは純正のカート追加（handleSubmit→/cart/add）に先行できない
//    （実測 2026-07-03: submit ガード発火後も /cart/add が飛び無効日がカートに入った）。
//    対策＝3層: (a) ネイティブ制約検証への相乗り＝無効な間は「検証キャリア」（Liquid 側の
//    非表示 input・name 無し）に setCustomValidity() を立て、純正 handleClick の
//    form.checkValidity() と Enter キー暗黙送信のブラウザ検証を入口で止める
//    (b) クリック段階のガード＝ネイティブ送信が始まる前なので preventDefault が確実に効く
//    (c) 既存の submit capture ガードは最終網として残置。
// 上記以外のロジック（送信ガード・日付検証・sessionStorage 復元・pageshow 整合）は Dawn 版と同一。
// ページ読み込み完了後に実行するスクリプト
document.addEventListener('DOMContentLoaded', function() {
  var cfg = JSON.parse(document.getElementById('k-order-options-config').textContent);
  // 商品メタフィールドからリードタイムを取得
  const deliveryLeadTime = cfg.leadTime;
  const storeLeadTime = cfg.leadTimeStore;
  const isStoreOnly = cfg.isStoreOnly;

  // ショップメタフィールドから店舗別設定を取得
  const minamisayaExtraLeadDays = Number(cfg.minamisayaExtraLeadDays);

  function parseBlackoutDates(rawText) {
    if (!rawText) return [];
    return rawText.split(/[\n,\s]+/).map(function(s) { return s.trim(); })
                  .filter(function(s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });
  }
  const blackoutHonten = parseBlackoutDates(cfg.blackoutHonten);
  const blackoutMinamisaya = parseBlackoutDates(cfg.blackoutMinamisaya);
  const blackoutDelivery = parseBlackoutDates(cfg.blackoutDelivery);

  // 商品メタフィールドから販売期間・ブラックアウト期間を取得
  const productAvailableFrom = cfg.availableFrom || null;
  const productAvailableUntil = cfg.availableUntil || null;
  const productBlackoutFrom = cfg.blackoutFrom || null;
  const productBlackoutUntil = cfg.blackoutUntil || null;

  // ----- 表示制御ヘルパー（旧 jQuery slideUp/slideDown/hide/:visible の置換） -----
  // アニメーションは廃し即時切替。対象コンテナは display で出し分けする。
  function showEl(el) { if (el) el.style.display = ''; }
  function hideEl(el) { if (el) el.style.display = 'none'; }
  function isVisibleEl(el) {
    return !!el && window.getComputedStyle(el).display !== 'none';
  }

  // ----- スライド開閉ヘルパー（高さアニメ・Web Animations API） -----
  // 見た目だけを高さ 0 ⇄ 実寸でアニメする。データ処理(有効/無効・値)は呼び出し側で即時に行う。
  // prefers-reduced-motion / ms=0 のときは即時。連打時は進行中アニメを破棄して整合。
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slideAnims = new WeakMap();

  function cancelSlide(el) {
    var a = slideAnims.get(el);
    if (a) { a.cancel(); slideAnims.delete(el); }
  }
  function slideOpen(el, ms, done) {
    if (!el) { if (done) done(); return; }
    cancelSlide(el);
    el.style.display = '';
    if (prefersReducedMotion || !ms) { el.style.height = ''; el.style.overflow = ''; if (done) done(); return; }
    el.style.overflow = 'hidden';
    el.style.height = 'auto';
    var target = el.offsetHeight;   // 開いた時の高さを実測
    el.style.height = '0px';
    void el.offsetHeight;           // リフロー確定
    var anim = el.animate([{ height: '0px' }, { height: target + 'px' }], { duration: ms, easing: 'ease' });
    slideAnims.set(el, anim);
    anim.onfinish = function () { slideAnims.delete(el); el.style.height = ''; el.style.overflow = ''; if (done) done(); };
  }
  function slideClose(el, ms, done) {
    if (!el) { if (done) done(); return; }
    cancelSlide(el);
    if (window.getComputedStyle(el).display === 'none') { if (done) done(); return; }
    if (prefersReducedMotion || !ms) { el.style.display = 'none'; el.style.height = ''; el.style.overflow = ''; if (done) done(); return; }
    el.style.overflow = 'hidden';
    var start = el.offsetHeight;    // 現在の高さから 0 へ
    el.style.height = start + 'px';
    void el.offsetHeight;
    var anim = el.animate([{ height: start + 'px' }, { height: '0px' }], { duration: ms, easing: 'ease' });
    slideAnims.set(el, anim);
    anim.onfinish = function () { slideAnims.delete(el); el.style.display = 'none'; el.style.height = ''; el.style.overflow = ''; if (done) done(); };
  }

  // 日付を YYYY-MM-DD 文字列へ（旧 $.datepicker.formatDate('yy-mm-dd') の置換、内部比較用）
  function formatYMD(date) {
    var y = date.getFullYear();
    var m = ('0' + (date.getMonth() + 1)).slice(-2);
    var d = ('0' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
  }

  // スラッシュ表記(YYYY/MM/DD)を isDateAllowed が解するハイフン表記(YYYY-MM-DD)へ正規化。
  // 送信値(input.value=スラッシュ)と選択日(selectedDates由来=ハイフン)を比較・検証する前に
  // 通すことで、「実質同じ日付なのに表記形式の違いだけで不一致」と誤判定しないようにする。
  function normalizeYMD(s) { return (s || '').trim().replace(/\//g, '-'); }

  // 日付が選択可能かを一元判定（カレンダーの見た目と送信時検査で同じルールを使う）。
  // 戻り値 true=選択OK。リードタイム前・3ヶ月超・販売期間外・商品/店舗ブラックアウトは false。
  // ここを唯一のルールにすることで、カレンダー表示と送信時バリデーションが食い違わない。
  function isDateAllowed(dateStr, minDaysOffset, blackoutDates) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false; // 形式不正は不可
    blackoutDates = blackoutDates || [];
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var min = new Date(today); min.setDate(min.getDate() + Number(minDaysOffset));
    var max = new Date(today); max.setMonth(max.getMonth() + 3);
    var minStr = formatYMD(min), maxStr = formatYMD(max);
    if (dateStr < minStr) return false;              // リードタイムより前
    if (dateStr > maxStr) return false;              // 3ヶ月より先
    if (productAvailableFrom && dateStr < productAvailableFrom) return false;   // 販売開始前
    if (productAvailableUntil && dateStr > productAvailableUntil) return false; // 販売終了後
    if (productBlackoutFrom && productBlackoutUntil &&
        dateStr >= productBlackoutFrom && dateStr <= productBlackoutUntil) return false; // 商品ブラックアウト
    if (blackoutDates.indexOf(dateStr) !== -1) return false; // 店舗/配送ブラックアウト
    return true;
  }

  // Flatpickr 用 日本語ロケール（l10n/ja.js を別ファイルにせず内蔵）
  var jaLocale = {
    weekdays: {
      shorthand: ['日', '月', '火', '水', '木', '金', '土'],
      longhand: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
    },
    months: {
      shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    rangeSeparator: ' 〜 ',
    weekAbbreviation: '週',
    firstDayOfWeek: 0,
    yearAriaLabel: '年',
    monthAriaLabel: '月'
  };

  // Flatpickr インスタンスの保持（要素IDごと）
  var fpInstances = {};

  // 最短日付を計算してセットする関数（表示形式は YYYY/MM/DD）
  function setMinDateToInput(elementId, leadTime) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    today.setDate(today.getDate() + Number(leadTime));
    var yyyy = today.getFullYear();
    var mm = ('0' + (today.getMonth() + 1)).slice(-2);
    var dd = ('0' + today.getDate()).slice(-2);
    var minDateStr = yyyy + '/' + mm + '/' + dd;
    var input = document.getElementById(elementId);
    // 無効化（非選択）の入力には日付を書かない。
    // 受取方法の切替直後に、カレンダーの非同期処理が無効化済みの
    // 入力へ最短日を書き戻し、受取り日などが混入する不具合の根本対策。
    if (input && !input.disabled) {
      var fp = fpInstances[elementId];
      if (fp) {
        fp.setDate(minDateStr, false); // 第2引数 false: onChange を発火させない
      } else {
        input.value = minDateStr;
      }
      return minDateStr; // 設定した日付を返す
    }
    return null;
  }

  // ピッカーの値をクリア（旧 input.value = "" の Flatpickr 対応版）
  function clearPicker(elementId) {
    var fp = fpInstances[elementId];
    if (fp) {
      fp.clear();
    } else {
      var input = document.getElementById(elementId);
      if (input) input.value = '';
    }
  }

  // ----- 受取方法の切り替え処理 -----
  // 受取方法選択ラジオボタンの取得
  const deliveryMethodRadios = document.querySelectorAll('input[name="properties[受取方法]"]');
  const deliveryContainer = document.getElementById('delivery-container');  // 宅配オプション表示部分
  const storeContainer = document.getElementById('store-container');        // 店頭受取オプション表示部分

  // 宅配関連の入力要素の有効/無効を切り替える関数
  // 引数 disabled が true の場合、宅配関連の入力が無効化され、一部の値がリセットされます。
  function disableDeliveryInputs(disabled) {
    // 配送日指定のラジオボタン
    document.querySelectorAll('input[name="properties[配送日指定の有無]"]').forEach(el => {
      el.disabled = disabled;

      // 店頭受取選択時（disabled=true）には、ラジオボタンの選択を解除する
      if (disabled && el.checked) {
        el.checked = false;
      }
    });

    // 配送希望日
    const deliveryDatepicker = document.getElementById('delivery-datepicker');
    if (deliveryDatepicker) {
      deliveryDatepicker.disabled = disabled ||
        document.getElementById('delivery-date-unspecified').checked;

      // 店頭受取選択時には値をリセット、宅配選択時には最短日をセット
      if (disabled) {
        clearPicker('delivery-datepicker');
      } else if (document.getElementById('delivery-date-specified').checked) {
        // 「指定する」が選択されている場合のみ最短日をセット
        setMinDateToInput('delivery-datepicker', deliveryLeadTime);
      }
    }

    // 宅配時間帯
    const deliveryTime = document.getElementById('delivery-time');
    if (deliveryTime) {
      deliveryTime.disabled = disabled ||
        document.getElementById('delivery-date-unspecified').checked;
      // 店頭受取選択時には値をリセット
      if (disabled) {
        // 店頭受取選択時は宅配時間帯の値を空にする。
        // disabledな要素の値も送信される場合があるため、不要な値がカートに入らないようにするため。
        deliveryTime.value = "";
      }
    }
  }

  // 店頭受取関連の入力要素の有効/無効を切り替える関数
  function disableStoreInputs(disabled) {
    // 受取り店舗ラジオボタン
    document.querySelectorAll('input[name="properties[受取り店舗]"]').forEach(el => {
      el.disabled = disabled;
      if (disabled && el.checked) {
        el.checked = false;
      }
    });
    // 有効化時は谷町本店をデフォルト選択
    if (!disabled) {
      const taniRadio = document.getElementById('pickup-store-tani');
      if (taniRadio) taniRadio.checked = true;
    }

    // 温度状態（冷凍または冷蔵の場合のみ）
    if (cfg.isTemperatureZoneStore) {
    document.querySelectorAll('input[name="properties[商品の温度状態]"]').forEach(el => {
      el.disabled = disabled;
      if (disabled && el.checked) {
        el.checked = false;
      }
    });
    }

    // 受取日
    const storeDatepicker = document.getElementById('store-datepicker');
    if (storeDatepicker) {
      storeDatepicker.disabled = disabled;
      if (disabled) {
        clearPicker('store-datepicker');
      } else {
        setMinDateToInput('store-datepicker', storeLeadTime);
      }
    }

    // 受取時間帯
    document.querySelectorAll('input[name="properties[受取り時間帯]"]').forEach(el => {
      el.disabled = disabled;
      if (disabled && el.checked) {
        el.checked = false;
      }
    });
  }

  // 受取方法に応じて表示/有効状態を組み立てる（change と pageshow 復元の両方から呼ぶ）。
  // 一本化しておくことで「ラジオの値」を唯一の真実として、いつでも表示・有効/無効を一致させられる。
  // animate=true（ユーザー操作）のときだけ高さスライドで切替。false（初期化/復元）は即時。
  function applyDeliveryMethod(deliveryType, animate) {
    if (deliveryType === "宅配") {
      // 店頭受取関連の入力要素をすべて無効化（送信されなくなる）
      disableStoreInputs(true);

      // 宅配関連の入力要素を有効化
      disableDeliveryInputs(false);

      // デフォルトの宅配設定を復元（指定しない を選択状態にする）
      document.getElementById('delivery-date-unspecified').checked = true;
      clearPicker('delivery-datepicker'); // 宅配日をリセット
      document.getElementById('delivery-time').value = "指定なし"; // 宅配時間をリセット
      hideEl(document.getElementById('delivery-datetime-container')); // 宅配日時選択を非表示
    } else {
      // 宅配関連の入力要素をすべて無効化（送信されなくなる）
      disableDeliveryInputs(true);

      // 店頭受取関連の入力要素を有効化
      disableStoreInputs(false);

      // デフォルトの店頭受取設定を一元管理（冷蔵と10時〜13時 を選択状態にする）
      // HTMLのchecked属性は使わず、ここでJavaScriptから初期値を設定
      if (cfg.isTemperatureZoneStore) {
        document.getElementById('temperature-refrigerated').checked = true;
      }
      document.getElementById('pickup-time-morning').checked = true;

      // 店頭受取日カレンダーに最短日をセット
      setMinDateToInput('store-datepicker', storeLeadTime);
    }

    // パネルの入替（データ処理は上で即時完了済み。ここは見た目だけ）
    var target = (deliveryType === "宅配") ? deliveryContainer : storeContainer;
    var other  = (deliveryType === "宅配") ? storeContainer : deliveryContainer;
    if (animate && !prefersReducedMotion) {
      // 順次：現パネルを閉じてから次パネルを開く（合計〜500ms・使い心地の好みでこちらを採用）。
      // 注意: 詳細カラム固定（sticky_details_desktop）が ON だと、ページ後半での切替時に
      // 高さの縮み→伸びがスクロール位置補正と噛み合って上下バウンドして見える（2026-07-04 実測）。
      // 現在は固定 OFF のため直列でも安定。バウンドが再発したら並走（close/open 同時実行）へ切替えること
      slideClose(other, 220, function () { slideOpen(target, 300); });
    } else {
      hideEl(other);   // 初期化・戻る復元時は即時
      showEl(target);
    }
  }

  // 各ラジオボタンの変更イベントをリッスン
  deliveryMethodRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      applyDeliveryMethod(this.value, true);  // ユーザー操作はアニメ
    });
  });

  // ----- 配送日指定の切り替え処理 -----
  // 配送日指定の有無ラジオボタンの取得
  const deliveryDateSpecificationRadios = document.querySelectorAll('input[name="properties[配送日指定の有無]"]');
  const deliveryDatetimeContainer = document.getElementById('delivery-datetime-container'); // 日時選択フォーム
  const deliveryDatepicker = document.getElementById('delivery-datepicker');               // 日付選択入力
  const deliveryTimeSelect = document.getElementById('delivery-time');                     // 時間帯選択入力

  // 配送日「指定する/しない」に応じて、日時欄の開閉・入力の有効/無効・既定値を整える共有関数。
  // change（ユーザー操作）と、戻る復元の両方から呼ぶ。これで見た目の挙動を1か所で管理できる。
  // animate=true のときだけ高さスライド(350ms)。false（復元/初期化）は即時(ms=0)でちらつかせない。
  function applyDeliverySpecState(isDateSpecified, animate) {
    var ms = animate ? 350 : 0;
    // 日付指定する場合は入力を有効化、しない場合は無効化
    deliveryDatepicker.disabled = !isDateSpecified;
    deliveryTimeSelect.disabled = !isDateSpecified;
    if (isDateSpecified) {
      slideOpen(deliveryDatetimeContainer, ms);
      setMinDateToInput('delivery-datepicker', deliveryLeadTime);
    } else {
      slideClose(deliveryDatetimeContainer, ms);
      // 日付指定しない場合は入力値をリセット
      clearPicker('delivery-datepicker');
      deliveryTimeSelect.value = "指定なし";
    }
  }

  // 各ラジオボタンの変更イベントをリッスン（操作時はアニメあり）
  deliveryDateSpecificationRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      applyDeliverySpecState(this.value === "指定する", true);
    });
  });

  // メッセージカード「あり/なし」に応じて入力欄の開閉・有効/無効・既定値を整える共有関数。
  // change（操作）と、戻る復元の両方から呼ぶ。メッセージ欄が無い商品では安全に何もしない。
  // animate=true のときだけ高さスライド(350ms)。false（復元）は即時(ms=0)。
  function applyMessageState(hasMessageCard, animate) {
    var container = document.getElementById('message-text-container');
    var textarea = document.getElementById('message-text');
    var count = document.getElementById('message-char-count');
    if (!container || !textarea) return;
    var ms = animate ? 350 : 0;
    // メッセージカードをつける場合は入力を有効化、しない場合は無効化
    textarea.disabled = !hasMessageCard;
    if (hasMessageCard) {
      slideOpen(container, ms);
    } else {
      slideClose(container, ms);
      // メッセージカードをつけない場合は入力値をリセット
      textarea.value = "";
      if (count) count.textContent = "0";
    }
  }

  // ----- メッセージカードの切り替え処理 -----
  if (cfg.hasMessageCard) {
  // メッセージカードの有無ラジオボタンの取得
  const messageCardRadios = document.querySelectorAll('input[name="properties[メッセージカード]"]');
  const messageTextArea = document.getElementById('message-text');                // メッセージテキストエリア
  const messageCharCount = document.getElementById('message-char-count');        // 文字数カウンター

  // 各ラジオボタンの変更イベントをリッスン（操作時はアニメあり）
  messageCardRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      applyMessageState(this.value === "あり", true);
    });
  });

  // メッセージ文字数カウンター
  messageTextArea.addEventListener('input', function() {
    const currentLength = this.value.length;
    messageCharCount.textContent = currentLength.toString();
  });
  }

  // ----- 備考文字数カウンター -----
  if (cfg.hasBikou) {
  const noteTextArea = document.getElementById('note-text');
  const noteCharCount = document.getElementById('note-char-count');

  if (noteTextArea && noteCharCount) {
    // 初期値を設定（空文字列）
    noteCharCount.textContent = "0";

    // 備考欄の内容が変更されたときの処理
    noteTextArea.addEventListener('input', function() {
      const currentLength = this.value.length;
      noteCharCount.textContent = currentLength.toString();
    });

    // 空の場合は何もしない（カートから除外されるように）
  }
  }

  // ----- カレンダー機能の共通処理 -----
  // 祝日データのキャッシュ（1回だけ取得して使い回す）
  let holidaysCache = null;

  function fetchHolidays() {
    if (holidaysCache) return Promise.resolve(holidaysCache);
    return fetch("https://holidays-jp.github.io/api/v1/date.json")
      .then(function(response) { return response.json(); })
      .then(function(data) { holidaysCache = data; return data; });
  }

  // 祝日判定（色分け専用。選択可否には影響させない）
  function isHoliday(date) {
    return !!(holidaysCache && holidaysCache[formatYMD(date)]);
  }

  /**
   * Flatpickr でカレンダーを初期化。
   * 選択不可(disable)にするのは「販売期間外 / 商品ブラックアウト範囲 / 店舗別ブラックアウト日」のみ。
   * リードタイム前は minDate、+3ヶ月超は maxDate で制御。
   * 土日・祝日は onDayCreate で色分けするが選択は可能（disable しない）。
   * @param {string} elementId - カレンダーを適用する要素のID
   * @param {number|string} minDaysOffset - 最小選択可能日（現在日から何日後か）
   * @param {string[]} blackoutDates - 受付不可日の配列（YYYY-MM-DD形式）
   */
  function initializeCalendar(elementId, minDaysOffset, blackoutDates) {
    blackoutDates = blackoutDates || [];
    var el = document.getElementById(elementId);
    if (!el) return;

    // 既に初期化済みの場合は破棄して再生成
    if (fpInstances[elementId]) {
      fpInstances[elementId].destroy();
      delete fpInstances[elementId];
    }

    var minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate() + Number(minDaysOffset));
    var maxDate = new Date();
    maxDate.setHours(0, 0, 0, 0);
    maxDate.setMonth(maxDate.getMonth() + 3);

    fpInstances[elementId] = flatpickr(el, {
      locale: jaLocale,
      dateFormat: 'Y/m/d',
      minDate: minDate,
      maxDate: maxDate,
      disableMobile: true, // モバイルでもネイティブ入力に逃がさず Flatpickr の制御下に置く
      disable: [
        function(date) {
          // カレンダーの見た目も、送信時検査と同じ isDateAllowed で一元判定する
          return !isDateAllowed(formatYMD(date), minDaysOffset, blackoutDates);
        }
      ],
      onDayCreate: function(selectedDates, dateStr, instance, dayElem) {
        // 土日・祝日は色分けのみ（選択可。disable はしない）
        var d = dayElem.dateObj;
        var dow = d.getDay();
        if (dow === 0) dayElem.classList.add('day-sunday');
        else if (dow === 6) dayElem.classList.add('day-saturday');
        else dayElem.classList.add('day-weekday');
        if (isHoliday(d)) dayElem.classList.add('day-holiday');
      }
    });

    setMinDateToInput(elementId, minDaysOffset);
  }

  // ----- カレンダーの初期化 -----
  initializeCalendar('delivery-datepicker', deliveryLeadTime, blackoutDelivery);
  initializeCalendar('store-datepicker', storeLeadTime, blackoutHonten);

  // 祝日データ取得後、色分け（day-holiday）を反映するため再描画
  fetchHolidays().then(function() {
    Object.keys(fpInstances).forEach(function(id) {
      if (fpInstances[id]) fpInstances[id].redraw();
    });
  }).catch(function(err) { console.error('カレンダーデータの取得に失敗:', err); });

  // ----- 店舗選択変更時のカレンダー再初期化 -----
  document.querySelectorAll('input[name="properties[受取り店舗]"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var leadTime, blackout;
      if (this.value === '南斎院店') {
        leadTime = Number(storeLeadTime) + minamisayaExtraLeadDays;
        blackout = blackoutMinamisaya;
      } else {
        leadTime = Number(storeLeadTime);
        blackout = blackoutHonten;
      }
      var leadDisplay = document.getElementById('store-lead-display');
      if (leadDisplay) leadDisplay.textContent = leadTime;
      initializeCalendar('store-datepicker', leadTime, blackout);
      updateNativeValidity(); // 店舗切替でリードタイム/受付不可日が変わる＝検証状態を更新
    });
  });

  // 初期状態では店頭受取関連の入力要素を無効化
  disableStoreInputs(true);

  // 初期状態の設定 -----
  if (isStoreOnly) {
    // 店舗受取限定の場合
    disableDeliveryInputs(true); // 宅配関連を無効化
    disableStoreInputs(false); // 店頭受取関連を有効化

    // 店頭受取のデフォルト値を設定
    if (cfg.isTemperatureZoneStore) {
    document.getElementById('temperature-refrigerated').checked = true;
    }
    document.getElementById('pickup-time-morning').checked = true;
    setMinDateToInput('store-datepicker', storeLeadTime);

    // hidden input for 受取方法
    let hiddenInput = document.querySelector('input[name="properties[受取方法]"][value="店頭受取"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[受取方法]';
      hiddenInput.value = '店頭受取';
      hiddenInput.form = cfg.productFormId;
      const form = document.getElementById(cfg.productFormId) || document.querySelector('form[id^="BuyButtons-ProductForm-"]');
      if (form) {
         form.appendChild(hiddenInput);
      }
    } else {
      // ラジオボタンが表示されていない場合でも、カートプロパティとして送信されるように値を設定
       const pickupRadio = document.getElementById('delivery-method-pickup');
       if(pickupRadio) pickupRadio.checked = true;
    }


  } else {
    // 通常の場合（宅配がデフォルト）
    disableStoreInputs(true);  // 店頭受取関連を無効化
    disableDeliveryInputs(false); // 宅配関連を有効化
    // デフォルトの宅配設定（指定しない）
    const deliveryDateUnspecified = document.getElementById('delivery-date-unspecified');
    if (deliveryDateUnspecified) deliveryDateUnspecified.checked = true;
    hideEl(document.getElementById('delivery-datetime-container')); // 宅配日時選択を非表示に
  }

  updateNativeValidity(); // 初期状態のネイティブ検証状態を確定（差分③(a)）

  // ----- 戻る/進む・bfcache 復元時の整合（壊れた注文の防止） -----
  // bfcache 不使用の戻りでは、ブラウザが受取方法ラジオだけを復元して change を発火せず、
  // かつ初期化JSが宅配既定でレイアウトを組むため「店頭受取なのに宅配フォーム＋店頭入力は無効」
  // という食い違い（=壊れた送信状態）が起きうる。実際に checked のラジオを唯一の真実とし、
  // 表示が食い違う時だけ受取方法のセットアップを再適用して、表示・有効/無効を必ず一致させる。
  // ※一致している時（bfcacheで正しく復元された場合等）は何もしないので、復元済みの状態は壊さない。
  window.addEventListener('pageshow', function() {
    var checked = document.querySelector('input[name="properties[受取方法]"]:checked');
    if (!checked) return; // storeOnly 等、受取方法ラジオが無い場合は対象外
    var storeShown = isVisibleEl(storeContainer);
    var deliveryShown = isVisibleEl(deliveryContainer);
    var consistent = (checked.value === '宅配' && deliveryShown && !storeShown) ||
                     (checked.value === '店頭受取' && storeShown && !deliveryShown);
    if (!consistent) {
      applyDeliveryMethod(checked.value, false);  // 復元/整合は即時（チラつき防止）
    }
    updateNativeValidity(); // bfcache 復元後の状態でも検証状態を最新化（差分③(a)）
  });

  // ----- 送信時の権威的な整え＋無効日ブロック（クラス1/2 の構造的根絶） -----
  // 「常に正しく保つ」のではなく「送る瞬間に確定させる」。bfcache/非同期で
  // 状態がずれていても、送る直前に非選択ブランチを落とし、日付を検証する。

  // 受取方法を唯一の真実として取得（storeOnly はラジオが無く hidden で店頭受取）
  function getActiveMethod() {
    var checked = document.querySelector('input[name="properties[受取方法]"]:checked');
    if (checked) return checked.value;
    var any = document.querySelector('input[name="properties[受取方法]"]');
    if (any) return any.value;
    return isStoreOnly ? '店頭受取' : '宅配';
  }

  // 選択中の受取方法に対応する「日付欄と検証ルール」を返す
  function getActiveDateContext(method) {
    if (method === '宅配') {
      var specified = document.getElementById('delivery-date-specified');
      if (!specified || !specified.checked) return { required: false }; // 「指定しない」は日付不要
      return { required: true, inputId: 'delivery-datepicker',
               minDaysOffset: deliveryLeadTime, blackoutDates: blackoutDelivery };
    }
    // 店頭受取：選択中の店舗でリードタイム/ブラックアウトが変わる
    var storeRadio = document.querySelector('input[name="properties[受取り店舗]"]:checked');
    if (storeRadio && storeRadio.value === '南斎院店') {
      return { required: true, inputId: 'store-datepicker',
               minDaysOffset: Number(storeLeadTime) + minamisayaExtraLeadDays,
               blackoutDates: blackoutMinamisaya };
    }
    return { required: true, inputId: 'store-datepicker',
             minDaysOffset: Number(storeLeadTime), blackoutDates: blackoutHonten };
  }

  // ----- ネイティブ制約検証への相乗り（Horizon 貫通対策の本丸・差分③(a)） -----
  // 「現在の選択が無効な間は、フォーム自体をネイティブに invalid にしておく」。
  // 日付入力は readonly＝制約検証の対象外のため、検証キャリア（非表示・name 無し＝送信されない）
  // に setCustomValidity() を立てる。これで ①購入ボタンの純正 handleClick（form.checkValidity()）
  // ②Enter キー等の暗黙送信（ブラウザの送信前検証）の両方が入口で止まる。
  var validityCarrier = document.querySelector('.k-order-validity-carrier');

  // 現在の選択の問題点を返す（'' = 問題なし）。送信ガードと同じ isDateAllowed を使う。
  function computeDateIssue() {
    var ctx = getActiveDateContext(getActiveMethod());
    if (!ctx.required) return '';
    var input = document.getElementById(ctx.inputId);
    var submittedStr = normalizeYMD(input ? input.value : '');
    if (!submittedStr) return '日付が選択されていません。受取／お届け日を選んでください。';
    if (!isDateAllowed(submittedStr, ctx.minDaysOffset, ctx.blackoutDates)) {
      return 'この日付は選択できません。別の日をお選びください。';
    }
    return '';
  }

  function updateNativeValidity() {
    if (!validityCarrier) return;
    validityCarrier.setCustomValidity(computeDateIssue());
  }

  // エラー表示（理由をフィールド近くに出す。alert は使わない）
  function showOrderError(input, message) {
    var err = document.getElementById('k-order-options-error');
    if (!err) {
      err = document.createElement('div');
      err.id = 'k-order-options-error';
      err.setAttribute('role', 'alert');
      err.style.color = '#c0392b';
      err.style.fontWeight = 'bold';
      err.style.marginTop = '8px';
    }
    err.textContent = message;
    var box = input.closest('.date-input-container') || input.parentNode;
    box.appendChild(err);
    input.focus();
    input.scrollIntoView({ block: 'center' });
  }
  function clearOrderError() {
    var err = document.getElementById('k-order-options-error');
    if (err) err.textContent = '';
  }

  // 送信時ハンドラ（capture フェーズ＝Dawn の送信処理より先に走る）
  function onOrderSubmit(evt) {
    clearOrderError();
    var method = getActiveMethod();

    // (1) 非選択ブランチを強制的に無効化＝混入の構造的排除（選択側の値は触らない）
    if (method === '宅配') {
      disableStoreInputs(true);
    } else {
      disableDeliveryInputs(true);
    }

    // (2) 選択ブランチの日付を検証（無効ならブロック＋理由＋ログ）
    var ctx = getActiveDateContext(method);
    if (ctx.required) {
      var input = document.getElementById(ctx.inputId);
      var fp = fpInstances[ctx.inputId];
      // 実際に送信される値（input.value）を権威として検証する＝「検証する値」と「送る値」を一致させる。
      // selectedDates だけを見ると、bfcache/復元で input.value が陳腐化した場合に
      // 「カレンダー上は有効・実送信は無効」を見逃しうる（クラス2の残リスク）。
      var submittedStr = normalizeYMD(input ? input.value : '');               // 実送信値（正規化）
      var pickedStr = (fp && fp.selectedDates[0]) ? formatYMD(fp.selectedDates[0]) : ''; // 表示上の選択日
      var reason = '';
      var clearOnBlock = false;
      if (!submittedStr) {
        reason = '日付が選択されていません。受取／お届け日を選んでください。';
      } else if (!isDateAllowed(submittedStr, ctx.minDaysOffset, ctx.blackoutDates)) {
        reason = 'この日付は選択できません。別の日をお選びください。';
      } else if (pickedStr && pickedStr !== submittedStr) {
        // 送信値とカレンダー選択日が食い違う曖昧な状態（bfcache/復元等）。どちらが本意か
        // JS では断定できないため、自動で寄せず安全側に倒して再選択を促す（沈黙マスキングしない）。
        reason = '日付の状態を確認できませんでした。お手数ですが日付をもう一度お選びください。';
        clearOnBlock = true;
      }
      if (reason) {
        evt.preventDefault();
        evt.stopImmediatePropagation(); // Dawn の add-to-cart を止める
        // 観測用ログ（後から頻度を測れる形。沈黙させない）
        var rec = { time: new Date().toISOString(), method: method,
                    inputId: ctx.inputId, date: submittedStr || '(空)',
                    picked: pickedStr || '(空)', reason: reason };
        (window.__orderOptionBlocks = window.__orderOptionBlocks || []).push(rec);
        console.warn('[order-options][blocked]', rec);
        if (clearOnBlock) clearPicker(ctx.inputId); // 曖昧状態は該当欄をクリアして再選択へ誘導
        if (input) showOrderError(input, reason);
        return;
      }
    }
    // 妥当：何も止めない。非選択ブランチは上で無効化済みなので送信データはクリーン。
  }

  // 商品フォームに capture フェーズで登録（<product-form> に付けて順序を確実化）
  var orderForm = document.getElementById(cfg.productFormId) ||
                  document.querySelector('form[id^="BuyButtons-ProductForm-"]');
  if (orderForm) {
    var productFormEl = orderForm.closest('product-form-component');
    if (productFormEl) {
      productFormEl.addEventListener('submit', onOrderSubmit, true);
      // 差分③(b): クリック段階のガード。Horizon の純正処理は document 委任で先に走るが、
      // click の間に preventDefault すればネイティブのフォーム送信自体が始まらない＝
      // submit イベントも純正のカート追加も発生しない。エラー表示もここで出す。
      productFormEl.addEventListener('click', function (evt) {
        var btn = evt.target && evt.target.closest
          ? evt.target.closest('button[type="submit"], [ref="addToCartButton"]')
          : null;
        if (btn) onOrderSubmit(evt);
      }, true);
    } else {
      // フォールバック：document で受け、対象フォームだけ処理
      document.addEventListener('submit', function(evt) {
        if (evt.target === orderForm) onOrderSubmit(evt);
      }, true);
    }
  }

  // ===== 戻る/再読込時の全選択保持（sessionStorage） =====
  // お客様が選んだ注文オプションを sessionStorage（タブ単位の一時保存。タブを閉じると消える・
  // 外部送信なし）に控え、ページに戻った時に選び直さずに済むようにする。
  //  ・非選択ブランチは復元しない＝property 混入(クラス1)は再発しない
  //  ・日付は復元時に isDateAllowed で再検証＝陳腐化した無効日(クラス2)を持ち込まない
  //  ・送信ガード onOrderSubmit が最終安全網として別途残る
  //  ・保存対象は .sorcie-receive 内の properties[...] を自動収集するため、項目を増減しても
  //    この保存/復元コードは原則変更不要（カートに送られる値＝保存する値、が常に一致）

  // 保存キーは商品ごとに分ける（別商品のページに前の商品の選択が出ないように）
  var STORAGE_KEY = 'k-order-opts-v1:' + (cfg.productId != null ? cfg.productId : window.location.pathname);
  var receiveRoot = document.querySelector('.sorcie-receive');
  var isRestoring = false;  // 復元中は保存を止める（書き戻しが保存を再発火する堂々巡りを防ぐ）
  var saveTimer = null;

  // 現在の全選択を素のオブジェクトに集める（properties[...] を自動収集）
  function collectOrderState() {
    var state = {};
    if (!receiveRoot) return state;
    receiveRoot.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var name = el.getAttribute('name');
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked) state[name] = el.value;       // 選択中のものだけ
      } else if (el.value !== '') {
        state[name] = el.value;                        // 日付/セレクト/テキスト
      }
    });
    return state;
  }

  // sessionStorage へ保存（try/catch でプライベートモード等の例外でもページを壊さない）
  function persistOrderState() {
    if (isRestoring) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ v: 1, fields: collectOrderState() }));
    } catch (e) { /* 保存はベストエフォート。失敗は無視 */ }
  }

  // 変更のたびに少し待ってまとめて1回保存（デバウンス＝過剰な書き込みの間引き）
  function scheduleSave() {
    if (isRestoring) return;
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(persistOrderState, 150);
  }

  // この商品の保存を消す（壊れた保存データを検出した時などに呼ぶ）
  function clearOrderState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // 保存日が「今も選べる日」のときだけ日付欄へ書き戻す（陳腐化した無効日は復元しない）
  function restoreDateField(inputId, savedValue, method) {
    if (!savedValue) return;
    var ctx = getActiveDateContext(method);  // 選択中の受取方法/店舗に対応した最短日・受付不可日
    if (!ctx.required || ctx.inputId !== inputId) return;
    if (!isDateAllowed(normalizeYMD(savedValue), ctx.minDaysOffset, ctx.blackoutDates)) return;
    var fp = fpInstances[inputId];
    if (fp) fp.setDate(savedValue, false);   // 第2引数 false: onChange を発火させない
    else {
      var input = document.getElementById(inputId);
      if (input) input.value = savedValue;
    }
  }

  // 保存済みの全選択を画面へ書き戻す（順序: 受取方法 → 細目 → メッセージ/備考）
  function restoreOrderState() {
    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) { return; }
    if (!raw) return;
    var saved;
    try { saved = JSON.parse(raw); } catch (e) { clearOrderState(); return; }
    var f = saved && saved.fields;
    if (!f) return;

    isRestoring = true;
    try {
      // (1) 受取方法を先に確定（これで宅配/店頭どちらの欄を使うかが決まる）
      var methodWanted = f['properties[受取方法]'];
      var methodRadios = document.querySelectorAll('input[name="properties[受取方法]"]');
      if (methodWanted && methodRadios.length) {
        methodRadios.forEach(function (r) { r.checked = (r.value === methodWanted); });
      }
      var method = getActiveMethod();
      applyDeliveryMethod(method, false);   // 表示・有効/無効を即時で組み立て（非選択側は無効のまま）

      if (method === '宅配') {
        // (2a) 宅配: 配送日指定 → 日付 → 時間帯
        var specWanted = f['properties[配送日指定の有無]'];
        if (specWanted) {
          document.querySelectorAll('input[name="properties[配送日指定の有無]"]').forEach(function (r) {
            r.checked = (r.value === specWanted);
          });
          var isSpec = (specWanted === '指定する');
          applyDeliverySpecState(isSpec, false);   // 欄の開閉・有効化（即時）
          if (isSpec) {
            restoreDateField('delivery-datepicker', f['properties[配送希望日]'], method);
            var dtime = document.getElementById('delivery-time');
            if (dtime && f['properties[宅配時間帯]'] != null) dtime.value = f['properties[宅配時間帯]'];
          }
        }
      } else {
        // (2b) 店頭: 店舗 →(カレンダー再構築)→ 温度 → 受取日 → 時間帯
        var storeWanted = f['properties[受取り店舗]'];
        if (storeWanted) {
          document.querySelectorAll('input[name="properties[受取り店舗]"]').forEach(function (r) {
            r.checked = (r.value === storeWanted);
          });
          // 店舗でリードタイム/受付不可日が変わるため、既存の店舗 change を発火してカレンダーを組み直す
          // （この change はカレンダー再構築のみで他項目は壊さない）。発火後に保存日を書き戻す。
          var checkedStore = document.querySelector('input[name="properties[受取り店舗]"]:checked');
          if (checkedStore) checkedStore.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var tempWanted = f['properties[商品の温度状態]'];
        if (tempWanted) {
          document.querySelectorAll('input[name="properties[商品の温度状態]"]').forEach(function (r) {
            r.checked = (r.value === tempWanted);
          });
        }
        restoreDateField('store-datepicker', f['properties[受取り日]'], method);
        var timeWanted = f['properties[受取り時間帯]'];
        if (timeWanted) {
          document.querySelectorAll('input[name="properties[受取り時間帯]"]').forEach(function (r) {
            r.checked = (r.value === timeWanted);
          });
        }
      }

      // (3) メッセージカード（ある商品のみ）
      if (cfg.hasMessageCard) {
        var msgWanted = f['properties[メッセージカード]'];
        if (msgWanted) {
          document.querySelectorAll('input[name="properties[メッセージカード]"]').forEach(function (r) {
            r.checked = (r.value === msgWanted);
          });
          var hasMsg = (msgWanted === 'あり');
          applyMessageState(hasMsg, false);
          if (hasMsg) {
            var mt = document.getElementById('message-text');
            if (mt && f['properties[メッセージ内容]'] != null) {
              mt.value = f['properties[メッセージ内容]'];
              mt.dispatchEvent(new Event('input', { bubbles: true }));  // 文字数カウンタ更新
            }
          }
        }
      }

      // (4) 備考（ある商品のみ）
      if (cfg.hasBikou) {
        var nt = document.getElementById('note-text');
        if (nt && f['properties[備考]'] != null) {
          nt.value = f['properties[備考]'];
          nt.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    } catch (e) {
      // 復元で失敗したら、壊れた状態を残さないよう保存を消して既定のまま続行（ページは止めない）
      clearOrderState();
    } finally {
      isRestoring = false;
      updateNativeValidity(); // 復元後の状態で検証状態を最新化（差分③(a)）
    }
  }

  // 変更のたびに保存（change=ラジオ/セレクト/日付、input=テキスト入力）。委譲で1か所にまとめる。
  if (receiveRoot) {
    receiveRoot.addEventListener('change', function () { updateNativeValidity(); scheduleSave(); });
    receiveRoot.addEventListener('input', function () { updateNativeValidity(); scheduleSave(); });
  }
  // ページを離れる瞬間にも確実に保存（最後の変更の取りこぼし防止）
  window.addEventListener('pagehide', persistOrderState);

  // 注: カート追加後も保存を意図的に残す（戻って微調整→入れ直したい利用者を許容）。
  // 以前は cartUpdate 購読で消していたが、直後の pagehide 保存が「入力の残るフォーム」を
  // 保存し直すため実質無効で、かつ経路次第で「消えたり残ったり」と不安定だった（2026-06-15 検証）。
  // データはタブを閉じれば sessionStorage の性質で自然に消える。

  // 保存済みの選択を書き戻す（再読込/非bfcache戻り。bfcache戻りは DOM が生きているので既存 pageshow に任せる）
  restoreOrderState();
});
